// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_label__zYFs0 {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1200px) {
  .styles_label__zYFs0 {
    font-size: 12px;
  }
}

.styles_valueWrapper__DG--x {
  display: flex;
  gap: 4px;
}

.styles_value__90KYk {
  font-weight: 800;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: #ffffff;
}
@media (max-width: 1200px) {
  .styles_value__90KYk {
    font-size: 16px;
  }
}

.styles_addInfo__Zb7n3 {
  font-weight: 800;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/components/cardContent/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BCFS;ADAX;AEaE;EFhBF;IAQI,eAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,QAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cCzBM;ADwBR;AELE;EFCF;IAQI,eAAA;EAAF;AACF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BC/BS;AD+BX","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.label {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-50;\n\n  @include xl {\n    font-size: 12px;\n  }\n}\n\n.valueWrapper {\n  display: flex;\n  gap: 4px;\n}\n\n.value {\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white;\n\n  @include xl {\n    font-size: 16px;\n  }\n}\n\n.addInfo {\n  font-weight: 800;\n  font-size: 16px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white-50;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `styles_label__zYFs0`,
	"valueWrapper": `styles_valueWrapper__DG--x`,
	"value": `styles_value__90KYk`,
	"addInfo": `styles_addInfo__Zb7n3`
};
export default ___CSS_LOADER_EXPORT___;
